import React, {useState, useContext, useEffect} from "react";
import axios from "../common/axios";
import {UserContext} from "../common/UserContext";
import {TemplateContext} from "../common/TemplateContext";
import {ContentContext} from "../common/ContentContext";
import {ShortcutContext} from "../common/ShortcutContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import ListItem from "../common/ListItem";
import ListGroup from "../common/ListGroup";
import CircularLoader from "../common/CircularLoader";
import {BrandContext} from "../common/BrandContext";
import {NavigationContext} from "../common/NavigationContext";

const TestNavigation = props => {
    const {grouping = true, tabIndex= 0} = props;
    const {user, setUser} = useContext(UserContext);
    const [isLoading, setLoading] = useState(true);
    const {singlePage} = useContext(TemplateContext);
    const brandConfig = useContext(BrandContext);
    const [studentTestResults, setStudentTestResults] = useState([]);
    const {loadShortcutByUrl} = useCurrentShortcut();
    let otherListGroupOptions  = {}
    if (props.indicatorPlacement) otherListGroupOptions.indicatorPlacement = props.indicatorPlacement;
    const { setNavVisible } = useContext(NavigationContext);

    const loadStudentTestResults = () => {
        axios.get('/web/ui/test/openStudentTestAssignments',{params:{pageNumber:1, pageSize:20}})
            .then(response => {
                setStudentTestResults(response.data.content);
                setLoading(false);
            });
    }

    useEffect(() => {
        if(user !== undefined && user.student) {
            loadStudentTestResults();
        } else {
            setLoading(false);
        }
    }, []);

    if(isLoading) {
        return <CircularLoader pageCentered={false}/>;
    }

    const handleClick = () => {
        loadShortcutByUrl('/web/ui/view/test/studentTestAssignments');
        setNavVisible(false);

        if (globalReactFunctions && globalReactFunctions.handleTitleNavMenuClose) {
            globalReactFunctions.handleTitleNavMenuClose();
        }
    }

    if (grouping !== true) {
        if (studentTestResults === undefined || studentTestResults.length == 0) {
            return <ListItem isDisclosureItem={true} disabled={true}>You have no active Tests</ListItem>;
        } else {
            return (
                <>
                    {studentTestResults.map((studentTestResult, index) => {
                        return <ListItem isDisclosureItem={true} key={studentTestResult.testAssignmentId} onClick={handleClick}>
                            {studentTestResult.testName}
                        </ListItem>
                    })}
                </>
            )
        }
    }
    if (studentTestResults === undefined) {
        return null;
    }

    return (
        <ListGroup id={'tests-notifications-control'} isDisclosureItem={true} title={'My latest '+brandConfig.testsName} tabIndex={tabIndex} itemCount={studentTestResults.length} disabled={studentTestResults.length == 0} startOpen={studentTestResults.length > 0} {...otherListGroupOptions}>
            {studentTestResults.map((studentTestResult, index) => {
                return <ListItem isDisclosureItem={true} className={'ch-link'} key={studentTestResult.testAssignmentId} onClick={handleClick}>
                    {studentTestResult.testName}
                </ListItem>
            })}
        </ListGroup>
    );
}

export default TestNavigation;
